import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIncrementZoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      fill="#787887"
      d="M9.75 6.125v.75a.38.38 0 0 1-.375.375H7.25v2.125a.38.38 0 0 1-.375.375h-.75a.36.36 0 0 1-.375-.375V7.25H3.625a.36.36 0 0 1-.375-.375v-.75a.38.38 0 0 1 .375-.375H5.75V3.625a.38.38 0 0 1 .375-.375h.75c.188 0 .375.188.375.375V5.75h2.125c.188 0 .375.188.375.375m6.125 9.063-.719.718c-.125.156-.375.156-.531 0l-3.781-3.781a.5.5 0 0 1-.094-.281v-.406A6.58 6.58 0 0 1 6.5 13 6.495 6.495 0 0 1 0 6.5C0 2.938 2.906 0 6.5 0 10.063 0 13 2.938 13 6.5a6.54 6.54 0 0 1-1.594 4.25h.406c.094 0 .188.063.282.125l3.781 3.781c.156.156.156.406 0 .531M11.5 6.5c0-2.75-2.25-5-5-5-2.781 0-5 2.25-5 5 0 2.781 2.219 5 5 5 2.75 0 5-2.219 5-5"
    />
  </svg>
);
export default SvgIncrementZoom;
